// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__23v3Z","errors":"Errors_errors__3mpBJ"};